//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react"

// === API ===
import { on, removeListener, requestStatsScehdule } from "api/prokey/prokey.websocket";


//#endregion


const SchedulerContext = createContext()

//-----------------------------------------------------------------
function SchedulerProvider( { children } ) {
  //-----------------------------------------------------------------
  const [ schedule_data , setScheduleData ] = useState( []    );
  const [ is_loading    , setIsLoading    ] = useState( false );
  const [ selected      , setSelected     ] = useState( null  )

  const values = { 
    schedule_data , setScheduleData ,
    is_loading    , setIsLoading    ,
    selected      , setSelected     ,
  };

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function listener_schedule(data) {
      //-----------------------------------------------------------------
      setScheduleData(data);
    }

    on( 'STATS-SCHEDULE' , listener_schedule );

    requestStatsScehdule();

    return () => {
      removeListener( 'STATS-SCHEDULE' , listener_schedule );
    };
  }, [])
  

  //#endregion

  return (
    <SchedulerContext.Provider value={ values }>
      {children}
    </SchedulerContext.Provider>
  );
};

export { SchedulerContext, SchedulerProvider };